import React from 'react'
import videoSrc from "../images/WhatsApp Video 2026-04-01 at 23.09.29.mp4"
import '../css/equipacion.css'

function Equipacion() {
  return (
    <div className="equipacion-wrapper">
      <div className="video-container">
        <video
          src={videoSrc}
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
        >
          Tu navegador no soporta vídeos.
        </video>
      </div>
    </div>
  )
}

export default Equipacion